import { Component, OnInit, Input, ViewChild, ElementRef, HostListener } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSidenav } from '@angular/material/sidenav';
import { WarningBoxComponent } from 'src/app/components';
import { AuthService } from 'src/app/services/auth.service';
import { environment } from 'src/environments/environment';
import { Messages } from '../../data/messages';
import { Profile } from '../../data/profile';
import { ChatService } from 'src/app/services/chat.service';
import { retryWhen, tap, delay, concatMap, of } from 'rxjs';
import { NewChat, Notifications, NewNotifications } from 'src/app/models/chat';
import { Router } from '@angular/router';
import { ScribbleService } from 'src/app/services/scribble.service';
@Component({
    selector: 'app-vertical-header',
    templateUrl: './vertical-header.component.html',
    styleUrls: ['./vertical-header.component.scss'],
})
export class VerticalHeaderComponent implements OnInit {
    base_url = environment.baseApiUrl;
    current_user: any;
    profile_pic = this.authservice.profile_pic;

    @ViewChild('Div') div: any;
    @ViewChild('ground') ground: any;
    @Input() sidebartoggle: MatSidenav | any;

    public showSearch = false;
    public chatNotifications: Notifications[] = [];
    public moreNotifications: any[] = [];
    public messages: any[] = Messages;
    public profiles: any[] = Profile;
    public newNotifications: NewNotifications[] = [];

    newChat: NewChat;
    newNotificationFlag: boolean = true;
    nextPage: number = 0;
    selectedFont: string = 'medium';

    onMouseMove(e: any) {
        // console.log(e);
    }
    move = (e: any) => {
        // console.log(e);
        this.div._elementRef.nativeElement.style.top = e.layerY - 263 + 'px';
        // console.log(this.div._elementRef.nativeElement.style.top);
    };

    constructor(
        private authservice: AuthService,
        public dialog: MatDialog,
        public chatService: ChatService,
        private router: Router,
        private elementRef: ElementRef,
        private scribbleService: ScribbleService
    ) { }

    ngOnInit(): void {
        this.current_user = JSON.parse(localStorage.getItem('current_user'));
        this.authservice.profile_pic_changed.subscribe((new_profile_pic) => {
            if (new_profile_pic != null) this.profile_pic = new_profile_pic;
        });

        this.chatService.initiateChat(this.authservice.getToken());

        setTimeout(() => {
            this.getNotificationMessages();
        }, 3000);


    }

    getNotificationMessages() {
        this.chatService.wsSubject$
            // .pipe(this.handleRetryError(2000))
            .subscribe({
                next: (msg) => {
                    console.log('msg------------->', msg);
                    if (msg.event == 'init_connection') {
                        this.chatService.wsSubject$.subscribe();
                        this.newChat = {
                            type: 'stats'
                        };
                        this.chatService.wsSubject$.next(this.newChat);
                    } else if (msg.event == 'latest_message_notifications') {
                        this.chatNotifications = msg.data;
                    } else if (msg.event == 'new_notification') {
                        this.newNotifications.unshift(msg.data);
                        this.newNotificationFlag = true;
                        this.chatService.noAccessToChat = false;
                        this.showPushNotification(msg);
                        let audio = new Audio();
                        audio.src = "assets/audio/notification.mp3";
                        audio.load();
                        audio.play();
                    } else if (msg.event == 'latest_notifications') {
                        this.nextPage = msg.extra_data.next_page;
                        if (msg.data.length != 0) {
                            msg.data.map(notification => {
                                this.newNotifications.push(notification);
                            })
                        }
                    } else if (msg.event == 'new_chat_message') {
                        if (this.current_user.id != msg.data.sent_by.id)
                            this.chatService.setDocumentTitleOnNewMessage();
                    }
                    else if (msg.event == 'stats') {
                        if (msg.data.length != 0) {
                            if (msg.data.unread_messages >= 0) {
                                if (msg.data.unread_messages > 99)
                                    this.chatService.unreadChatCount = 99;
                                else
                                    this.chatService.unreadChatCount = msg.data.unread_messages;
                            }
                        }

                        this.newChat = {
                            type: 'latest_notifications',
                            context: {
                                page_size: 10,
                                page: 1
                            },
                        };
                        // console.log(this.newChat);
                        this.chatService.wsSubject$.next(this.newChat);
                    }

                    if (this.newNotifications.length != 0) {
                        this.newNotifications = this.newNotifications.filter(item => item.is_read != true);
                    }

                    // console.log(this.newNotifications);
                },
                error: (err) => {
                    console.log(err);
                },
                complete: () => {
                    console.log(
                        'Notifications Socket Disconnected ...............'
                    );
                },
            });

        if (this.newNotifications.length != 0) {
            this.newNotifications.sort((a, b) => {
                return new Date(a.created_at).getTime() - new Date(b.created_at).getTime();
            });
            this.newNotificationFlag = true;

        } else {
            this.newNotificationFlag = false;
        }
    }

    async showPushNotification(msg) {
        const permission = await Notification.requestPermission();
        if (permission === 'granted' || permission === 'default') {
            const notificationOptions = {
                body: msg.data.message,
                icon: '/assets/images/favicon.png',
                data: msg.data.redirect_url
            }

            const notification = new Notification('ARCON | Reimagining Container Logistics', notificationOptions);

            notification.addEventListener('click', (event) => {
                if (event?.target['data'] != null || event?.target['data'] != "")
                    window.open(window.location.origin + '/apps/chat', '_blank'); // + event?.target['data']);
            });

            setTimeout(() => {
                notification.close();
            }, 5000);
        }
        else
            throw new Error('Notification permission not granted');
    }


    getAllNotifications() {
        this.newChat = {
            type: 'latest_notifications',
            context: {
                page_size: 10,
                page: 1
            },
        };
        // console.log(this.newChat);
        this.chatService.wsSubject$.next(this.newChat);
    }

    handleRetryError(delayTime) {
        let retries = 0;
        let exceedAttemptLimit = 5;
        return retryWhen((error) => {
            return error.pipe(
                tap((err) => {
                    console.error('Got error', err);
                }),
                delay(delayTime),
                concatMap((err) => {
                    retries = retries + 1;
                    if (retries < exceedAttemptLimit) {
                        return of(err);
                    } else {
                        throw err;
                    }
                })
            );
        });
    }

    loadMore() {
        if (this.nextPage != null) {
            this.newChat = {
                type: 'latest_notifications',
                context: {
                    page_size: 10,
                    page: this.nextPage
                },
            };
            // console.log(this.newChat);
            this.chatService.wsSubject$.next(this.newChat);
        }
    }

    reloadNotification() {
        // this.notifications = [...Notifications];
    }

    signOut() {
        this.openWarningDialog('Do you want to Logout?', 'No', 'Yes');
    }

    openWarningDialog(label: string, action1: string, action2?: string) {
        const dialogRef = this.dialog.open(WarningBoxComponent, {
            panelClass: 'dialog-container-custom',
            data: {
                subTitle: label,
                parent: this,
                label1: action1,
                label2: action2,
                negativeAction: this.negativeResponse,
                positiveAction: this.positiveResponse,
            },
        });
        dialogRef.afterClosed();
    }

    positiveResponse(parent) {
        parent.authservice.doLogout();
    }

    negativeResponse(parent) {
        return;
    }

    // @TODO show initals on broken profile picture
    showInitials(eve) {
        // console.log('profile pic', eve);
    }

    loadRequest(notification: NewNotifications) {
        // console.log(notification.redirect_url);
        this.newNotifications = this.newNotifications.filter(item => item.id != notification.id);
        this.chatService.updateNotificationStatus(notification.id).subscribe(res => {
            // console.log("notifications", res);
        });
        this.router.navigateByUrl(notification.redirect_url);
    }

    readNotification() {
        this.newNotificationFlag = false;
    }

    clearMsgNotification(notification: Notifications) {
        this.chatNotifications = this.chatNotifications.filter(item => item.id != notification.id);
    }

    openChat() {
        this.chatService.unreadChatCount = 0;
        this.router.navigate(['/apps/chat']);
    }
    openSuggestion() {
        this.router.navigate(['/apps/suggestions']);
    }

    openNotes() {
        this.scribbleService.getNotes(this.authservice.getToken()).subscribe(res => {
            console.log(res);
            this.router.navigate(['/apps/notes']);
        })
    }

    async openCalculator() {
        window.open('Calculator:///', '_self');
    }

    setFontSize(sfont, fs) {
        this.authservice.defaultFontSize = fs;
        this.selectedFont = sfont;
        document.documentElement.style.setProperty('--regular-font-size', fs);
        console.log("font1", sfont, this.authservice.defaultFontSize);
    }
    goto_url: string = 'invoice/list'

    gotoApp() {
            if (this.goto_url != '') {
                let encodedUrl = encodeURIComponent(this.goto_url)
                console.log("this.goto_url", environment.arthakoshFrontendBaseUrl + '/authentication/handshake/?url=' + encodedUrl)
                window.open(environment.arthakoshFrontendBaseUrl + '/authentication/handshake/?url=' + encodedUrl, '_blank');
            }
    }
}
